import { useParams } from 'react-router';

/**
 * Simple helper that types the react-router useParams with
 * params used across the app.
 */
export const useTrainingParams = () =>
  useParams<{
    learnerId?: string;
    learnerTrainingId?: string;
    sequenceId?: string;
  }>();
